/* camada interativa do clone glowright (Focal + Shogun). Tudo por DELEGACAO na raiz das
   secoes clonadas: alvo que chega depois continua funcionando. */
(function () {
  var ROOT = '[class*="cl-sec-"],[class*="cl-pdp"]';
  function inClone(el) { return el && el.closest && el.closest(ROOT); }

  /* ---------- Shogun swiper (slider-v3) ---------- */
  function swState(c) {
    var wrap = c.querySelector('.swiper-wrapper');
    var slides = wrap ? [].slice.call(wrap.children).filter(function (s) { return /swiper-slide/.test(s.className); }) : [];
    return { wrap: wrap, slides: slides, i: +(c.getAttribute('data-cl-i') || 0) };
  }
  function swGo(c, n) {
    var st = swState(c); if (!st.wrap || !st.slides.length) return;
    var vw = c.querySelector('.shg-swiper') || c;
    var perView = Math.max(1, Math.round(vw.clientWidth / (st.slides[0].getBoundingClientRect().width || vw.clientWidth)));
    var max = Math.max(0, st.slides.length - perView);
    if (max === 0) return;
    n = n > max ? 0 : (n < 0 ? max : n);           /* loop como no original */
    c.setAttribute('data-cl-i', n);
    st.wrap.style.transitionDuration = '300ms';
    st.wrap.style.transform = 'translate3d(' + (-(st.slides[n].offsetLeft - st.slides[0].offsetLeft)) + 'px,0,0)';
    [].forEach.call(c.querySelectorAll('.swiper-pagination-bullet'), function (b, k) {
      b.classList.toggle('swiper-pagination-bullet-active', k === n);
      if (k === n) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }

  window.clSwGo = swGo;

  /* ---------- Focal native-carousel (scroll-snap) ---------- */
  function ncScroll(car, k) {
    var items = car.querySelectorAll('cl-native-carousel-item,.native-carousel__item');
    if (!items[k]) return;
    car.scrollTo({ left: items[k].offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!inClone(t)) return;
    /* swiper arrows / bullets */
    var arrow = t.closest('.swiper-button-next,.swiper-button-prev');
    var bullet = t.closest('.swiper-pagination-bullet');
    if (arrow || bullet) {
      var c = t.closest('.shg-swiper-container');
      if (c) {
        e.preventDefault();
        var i = +(c.getAttribute('data-cl-i') || 0);
        if (bullet) swGo(c, [].indexOf.call(bullet.parentNode.children, bullet));
        else swGo(c, i + (/next/.test(arrow.className) ? 1 : -1));
        return;
      }
    }
    /* Shogun accordion */
    var head = t.closest('.shogun-accordion-heading');
    if (head) {
      var acc = head.closest('.shogun-accordion'), body = acc && acc.querySelector(':scope > .shogun-accordion-body');
      if (body) {
        var open = !acc.classList.contains('cl-open');
        var wrapper = acc.closest('.shogun-accordion-wrapper');
        if (open && wrapper && !wrapper.hasAttribute('data-multi')) {
          [].forEach.call(wrapper.querySelectorAll(':scope > .shogun-accordion.cl-open'), function (o) {
            o.classList.remove('cl-open'); var b = o.querySelector(':scope > .shogun-accordion-body'); if (b) { b.style.display = 'none'; b.style.opacity = 0; }
          });
        }
        acc.classList.toggle('cl-open', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.display = open ? 'block' : 'none';
        body.style.opacity = open ? 1 : 0;
      }
      return;
    }
    /* Focal collapsible (FAQ, abas da PDP, menus do rodape) */
    var tog = t.closest('button[aria-controls],a[aria-controls]');
    if (tog) {
      var id = tog.getAttribute('aria-controls');
      var tgt = id && document.getElementById(id);
      if (tgt && /popover/i.test(tgt.tagName + ' ' + tgt.className)) {
        e.preventDefault();
        var po = !tgt.hasAttribute('open');
        if (po) tgt.setAttribute('open', ''); else tgt.removeAttribute('open');
        tog.setAttribute('aria-expanded', po ? 'true' : 'false');
        return;
      }
      if (tgt && /collapsible/i.test(tgt.tagName + ' ' + tgt.className)) {
        e.preventDefault();
        var op = tog.getAttribute('aria-expanded') !== 'true';
        tog.setAttribute('aria-expanded', op ? 'true' : 'false');
        if (op) { tgt.setAttribute('open', ''); tgt.style.overflow = 'hidden'; tgt.style.height = tgt.scrollHeight + 'px'; setTimeout(function () { if (tgt.hasAttribute('open')) { tgt.style.height = 'auto'; tgt.style.overflow = 'visible'; } }, 300); }
        else { tgt.style.height = tgt.scrollHeight + 'px'; tgt.style.overflow = 'hidden'; requestAnimationFrame(function () { tgt.style.height = '0px'; }); tgt.removeAttribute('open'); }
        return;
      }
    }
    /* Shogun tabs: li.shogun-tab[aria-controls] -> painel .shogun-tab-content */
    var stab = t.closest('li.shogun-tab');
    if (stab) {
      var ul = stab.parentNode, pid = stab.getAttribute('aria-controls');
      var border = ul.querySelector('.shogun-tab-border');
      [].forEach.call(ul.children, function (li) {
        var on = li === stab; li.classList.toggle('shogun-tab-active', on); li.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (border) stab.appendChild(border);
      var panel = document.getElementById(pid);
      if (panel) [].forEach.call(panel.parentNode.children, function (p) { p.classList.toggle('shogun-tab-active', p === panel); });
      return;
    }
    /* SectionTabs (Alpine do concorrente): .tablink[data-tab] ativa a aba e o .tabcontent */
    var tab = t.closest('.tablink[data-tab]');
    if (tab) {
      var st = tab.closest('cl-section-tabs, .section-tabs');
      if (st) {
        e.preventDefault();
        var id = tab.getAttribute('data-tab');
        [].forEach.call(st.querySelectorAll('.tablink[data-tab]'), function (b) {
          var on = b.getAttribute('data-tab') === id;
          b.classList.toggle('clx-active', on); b.classList.toggle('active', on);
        });
        [].forEach.call(st.querySelectorAll('.tabcontent'), function (c) { c.classList.toggle('active_tab', c.id === id); });
        return;
      }
    }
    /* Focal time-line: prev/next e abas de navegacao trocam o item e ROLAM a pista (como o Focal) */
    var tl = t.closest('cl-time-line, .timeline');
    if (tl && t.closest('.prev-next-button, .timeline__nav-item')) {
      e.preventDefault();
      var items0 = [].slice.call(tl.querySelectorAll('.timeline__item'));
      var cur = items0.findIndex(function (x) { return !x.hasAttribute('hidden'); });
      var nav = t.closest('.timeline__nav-item');
      var navs0 = [].slice.call(tl.querySelectorAll('.timeline__nav-item'));
      var n = nav ? navs0.indexOf(nav) : cur + (t.closest('.prev-next-button--next') ? 1 : -1);
      clTimelineSelect(tl, n, true);
      return;
    }
    /* prev/next generico: rola o conteiner rolavel da secao (recomendados, galeria) */
    var pn = t.closest('.prev-next-button');
    if (pn) {
      var sc0 = pn.closest('[class*="cl-sec-"]');
      var scs = sc0 ? [].slice.call(sc0.querySelectorAll('cl-scrollable-content, .product-list__inner, .gallery__list-wrapper, .scroller, [class*="scroll"]')) : [];
      var scroller = scs.filter(function (x) { var o = getComputedStyle(x).overflowX; return (o === 'auto' || o === 'scroll') && x.scrollWidth > x.clientWidth + 1; })[0];
      if (scroller) {
        e.preventDefault();
        var first = scroller.querySelector('cl-gallery-item, .gallery__item, cl-product-item, .product-item');
        var step = first ? first.getBoundingClientRect().width + 16 : scroller.clientWidth * 0.8;
        scroller.scrollBy({ left: (pn.classList.contains('prev-next-button--next') ? 1 : -1) * step, behavior: 'smooth' });
        [].forEach.call(scroller.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
      }
      return;
    }
    /* Focal page-dots -> press-list (logos trocam a citacao) / native-carousel */
    var dot = t.closest('cl-page-dots button, .page-dots button');
    if (dot) {
      var dots = dot.closest('cl-page-dots,.page-dots');
      var press = dots.closest('cl-press-list, .press-list');
      if (press) {
        var bs = [].slice.call(dots.querySelectorAll('button')), pk = bs.indexOf(dot);
        [].forEach.call(press.querySelectorAll('cl-press-item, .press-list__item'), function (x, j) { if (j === pk) x.removeAttribute('hidden'); else x.setAttribute('hidden', ''); });
        bs.forEach(function (b, j) { b.setAttribute('aria-current', j === pk ? 'true' : 'false'); });
        return;
      }
      var sec = dots.closest(ROOT);
      var car = sec && sec.querySelector('cl-native-carousel,.native-carousel');
      if (car) {
        var k = [].indexOf.call(dots.querySelectorAll('button'), dot);
        ncScroll(car, k);
        [].forEach.call(dots.querySelectorAll('button'), function (b, j) { b.setAttribute('aria-current', j === k ? 'true' : 'false'); });
      }
    }
  });

  /* popover: fechar pelo X / overlay */
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-action="close"],.popover__overlay');
    var po = c && c.closest('[open]');
    if (po && inClone(po) && /popover/i.test(po.tagName + ' ' + po.className)) {
      po.removeAttribute('open');
      var b = document.querySelector('[aria-controls="' + po.id + '"]'); if (b) b.setAttribute('aria-expanded', 'false');
    }
  });

  /* colecao: ordenacao e filtros recarregam a pagina com os parametros do Shopify */
  var ft;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!inClone(t)) return;
    if (t.name === 'sort_by' && t.type === 'radio') {
      var u = new URL(location.href); u.searchParams.set('sort_by', t.value); location.href = u.toString(); return;
    }
    var form = t.closest('#facet-filters-form');
    if (form) {
      clearTimeout(ft);
      ft = setTimeout(function () {
        var p = new URLSearchParams(new FormData(form));
        Array.from(p.keys()).forEach(function (k) { if (p.get(k) === '') p.delete(k); });
        location.search = p.toString();
      }, 500);
    }
  });

  /* native-carousel: dot acompanha o scroll do dedo */
  document.addEventListener('scroll', function (e) {
    var car = e.target;
    if (!car || !car.matches || !car.matches('cl-native-carousel,.native-carousel') || !inClone(car)) return;
    var items = car.querySelectorAll('cl-native-carousel-item,.native-carousel__item');
    if (!items.length) return;
    var w = items[0].getBoundingClientRect().width || 1;
    var k = Math.round(car.scrollLeft / w);
    var sec = car.closest(ROOT), dots = sec && sec.querySelector('cl-page-dots,.page-dots');
    if (dots) [].forEach.call(dots.querySelectorAll('button'), function (b, j) { b.setAttribute('aria-current', j === k ? 'true' : 'false'); });
  }, true);
})();

/* videos com poster (loader lazy do concorrente): src + play quando ficam >=50% visiveis por 2s */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var timers = new WeakMap();
  function arm(v) {
    if (v.__clLazy) return; v.__clLazy = 1;
    io.observe(v);
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (timers.get(v)) return;
        timers.set(v, setTimeout(function () {
          if (!v.getAttribute('src')) { v.src = v.getAttribute('data-cl-src'); }
          v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {});
        }, 2000));
      } else {
        clearTimeout(timers.get(v)); timers.delete(v);
        if (!v.paused) v.pause();
      }
    });
  }, { threshold: 0.5 });
  function scan() { [].forEach.call(document.querySelectorAll('video[data-cl-src]'), arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  setTimeout(scan, 1500);
})();

/* Flickity do Focal congelado pelo extract (viewport/slides com medidas do DESKTOP): relayout
   pela largura real + prev/next/dots do <flickity-controls> */
(function () {
  function layout(car) {
    var vp = car.querySelector('.flickity-viewport'), sl = car.querySelector('.flickity-slider');
    if (!vp || !sl) return;
    var items = [].slice.call(sl.children), w = vp.clientWidth || car.clientWidth;
    var i = +(car.getAttribute('data-cl-i') || 0);
    items.forEach(function (it, k) { it.style.transform = 'translateX(' + (k * w) + 'px)'; it.style.width = w + 'px'; });
    sl.style.transform = 'translateX(' + (-i * w) + 'px)';
    var sel = items[i];
    if (sel) { var h = sel.getBoundingClientRect().height; if (h > 0) vp.style.height = h + 'px'; }
  }
  function go(car, i) {
    var items = car.querySelectorAll('.flickity-slider > *'); if (!items.length) return;
    i = Math.max(0, Math.min(items.length - 1, i));
    car.setAttribute('data-cl-i', i);
    [].forEach.call(items, function (it, k) { it.classList.toggle('is-selected', k === i); if (k === i) it.removeAttribute('aria-hidden'); else it.setAttribute('aria-hidden', 'true'); });
    var sl = car.querySelector('.flickity-slider'); sl.style.transition = 'transform .35s ease';
    layout(car);
    var ctl = document.querySelector('[controls="' + car.id + '"]');
    if (ctl) [].forEach.call(ctl.querySelectorAll('[data-action="select"]'), function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  window.clFlkGo = go;
  function all() { return [].slice.call(document.querySelectorAll('[class*="cl-sec-"] cl-flickity-carousel.flickity-enabled, [class*="cl-pdp"] cl-flickity-carousel.flickity-enabled')); }
  function relayout() { all().forEach(layout); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cl-flickity-controls [data-action]');
    if (!b) return;
    var ctl = b.closest('cl-flickity-controls'), car = document.getElementById(ctl.getAttribute('controls'));
    if (!car) return;
    e.preventDefault();
    var i = +(car.getAttribute('data-cl-i') || 0), a = b.getAttribute('data-action');
    if (a === 'next') go(car, i + 1); else if (a === 'prev') go(car, i - 1);
    else if (a === 'select') go(car, [].indexOf.call(ctl.querySelectorAll('[data-action="select"]'), b));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relayout); else relayout();
  window.addEventListener('load', relayout);
  window.addEventListener('resize', relayout);
})();

/* prev/next de rolagem (galeria, recomendados): como no Focal, "anterior" desabilitado no
   inicio e "proximo" no fim */
(function () {
  function sync() {
    [].forEach.call(document.querySelectorAll('[class*="cl-sec-"] cl-prev-next-buttons'), function (pn) {
      if (pn.closest('cl-time-line')) return;
      var sec = pn.closest('[class*="cl-sec-"]');
      var sc = [].slice.call(sec.querySelectorAll('cl-scrollable-content, .product-list__inner, .gallery__list-wrapper, .scroller, [class*="scroll"]'))
        .filter(function (x) { var o = getComputedStyle(x).overflowX; return o === 'auto' || o === 'scroll'; })[0];
      if (!sc) return;
      var pv = pn.querySelector('.prev-next-button--prev'), nx = pn.querySelector('.prev-next-button--next');
      var max = sc.scrollWidth - sc.clientWidth - 1;
      if (pv) pv.disabled = sc.scrollLeft <= 0;
      if (nx) nx.disabled = max <= 0 || sc.scrollLeft >= max;
      if (!sc.__clSync) { sc.__clSync = 1; sc.addEventListener('scroll', function () { clearTimeout(sc.__t); sc.__t = setTimeout(sync, 80); }); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  window.addEventListener('load', sync); window.addEventListener('resize', sync);
})();

/* ---- Focal time-line (cl-pev09 / cl-pcob06): selecionar item = hidden/aria-current + barra
   (--transform N%, a var que o CSS do Focal le) + rolar a pista (centro no desktop, inicio da
   imagem no mobile) + sincronizar quando o usuario arrasta/rola a pista. ---- */
function clTimelineTarget(wr, it) {
  var d = it.getBoundingClientRect().left - wr.getBoundingClientRect().left + wr.scrollLeft;
  if (window.matchMedia('(min-width: 1000px)').matches) return d - (wr.clientWidth - it.offsetWidth) / 2;
  var img = it.querySelector('.timeline__image-wrapper') || it;
  return d - (wr.clientWidth - img.offsetWidth) / 2;
}
function clTimelineMark(tl, n) {
  var items = [].slice.call(tl.querySelectorAll('.timeline__item'));
  var navs = [].slice.call(tl.querySelectorAll('.timeline__nav-item'));
  n = Math.max(0, Math.min(items.length - 1, n));
  items.forEach(function (x, j) { if (j === n) x.removeAttribute('hidden'); else x.setAttribute('hidden', ''); });
  navs.forEach(function (b, j) { b.setAttribute('aria-current', j === n ? 'true' : 'false'); });
  var bar = tl.querySelector('.timeline__progress-bar');
  if (bar) { bar.style.removeProperty('--progress'); bar.style.setProperty('--transform', (items.length > 1 ? 100 / (items.length - 1) * n : 0) + '%'); }
  var pv = tl.querySelector('.prev-next-button--prev'), nx = tl.querySelector('.prev-next-button--next');
  if (pv) pv.disabled = n === 0; if (nx) nx.disabled = n === items.length - 1;
  var nw = tl.querySelector('.timeline__nav-wrapper');
  if (nw && navs[n] && nw.scrollWidth > nw.clientWidth + 1) {
    var nb = navs[n].getBoundingClientRect(), wb = nw.getBoundingClientRect();
    nw.scrollTo({ left: nw.scrollLeft + nb.left - wb.left - (nw.clientWidth - nb.width) / 2, behavior: 'smooth' });
  }
  tl._clIdx = n;
  return n;
}
function clTimelineSelect(tl, n, smooth) {
  n = clTimelineMark(tl, n);
  var wr = tl.querySelector('.timeline__list-wrapper');
  var it = tl.querySelectorAll('.timeline__item')[n];
  if (!wr || !it) return;
  tl._clLock = Date.now() + 900;
  wr.scrollTo({ left: Math.max(0, clTimelineTarget(wr, it)), behavior: smooth ? 'smooth' : 'auto' });
}
(function () {
  function bind(tl) {
    if (tl._clBound) return; tl._clBound = true;
    var wr = tl.querySelector('.timeline__list-wrapper'); if (!wr) return;
    var timer;
    wr.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (tl._clLock && Date.now() < tl._clLock) return;
        var items = [].slice.call(tl.querySelectorAll('.timeline__item')), best = 0, bd = 1e9;
        items.forEach(function (it, j) { var dd = Math.abs(Math.max(0, clTimelineTarget(wr, it)) - wr.scrollLeft); if (dd < bd) { bd = dd; best = j; } });
        if (best !== tl._clIdx) clTimelineMark(tl, best);
      }, 140);
    }, { passive: true });
  }
  function init() { [].forEach.call(document.querySelectorAll('cl-time-line, .timeline'), function (tl) {
    if (!tl.querySelector('.timeline__item')) return;
    bind(tl);
    var items = [].slice.call(tl.querySelectorAll('.timeline__item'));
    tl._clIdx = Math.max(0, items.findIndex(function (x) { return !x.hasAttribute('hidden'); }));
  }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---- Swipe por toque (e arraste de mouse) nos sliders movidos por transform, que so tinham
   setas/bullets: swiper do Shogun (home "Explore Our Sensors", Hand Sensor), Flickity e press-list
   do Focal. touch-action:pan-y deixa a rolagem vertical com o navegador e entrega o gesto
   horizontal ao JS; a trilha acompanha o dedo e no fim vai para o vizinho (limiar 15% / 60px)
   ou volta. Um arraste real cancela o clique seguinte (links dentro do slide). ---- */
(function () {
  var SCOPE = '[class*="cl-sec-"] ', SCOPE2 = '[class*="cl-pdp"] ';
  var SEL = [SCOPE + '.shg-swiper-container', SCOPE + 'cl-flickity-carousel.flickity-enabled', SCOPE + 'cl-press-list',
             SCOPE2 + 'cl-flickity-carousel.flickity-enabled'].join(',');
  try {
    var st = document.createElement('style');
    st.textContent = SEL.split(',').map(function (s) { return s + '{touch-action:pan-y}'; }).join('') +
      SCOPE + '.shg-swiper-container img,' + SCOPE + 'cl-flickity-carousel img{-webkit-user-drag:none;user-select:none}';
    document.head.appendChild(st);
  } catch (e) {}
  function kind(c) { return c.matches('.shg-swiper-container') ? 'sw' : c.matches('cl-press-list') ? 'press' : 'flk'; }
  function track(c, k) { return k === 'sw' ? c.querySelector('.swiper-wrapper') : k === 'flk' ? c.querySelector('.flickity-slider') : null; }
  function tx(el) { try { return new DOMMatrixReadOnly(getComputedStyle(el).transform).m41; } catch (e) { return 0; } }
  function pressGo(c, n) {
    var items = [].slice.call(c.querySelectorAll('cl-press-item, .press-list__item')); if (items.length < 2) return;
    n = (n + items.length) % items.length;
    items.forEach(function (x, j) { if (j === n) x.removeAttribute('hidden'); else x.setAttribute('hidden', ''); });
    [].forEach.call(c.querySelectorAll('cl-page-dots button, .page-dots button'), function (b, j) { b.setAttribute('aria-current', j === n ? 'true' : 'false'); });
  }
  function pressIdx(c) { return Math.max(0, [].slice.call(c.querySelectorAll('cl-press-item, .press-list__item')).findIndex(function (x) { return !x.hasAttribute('hidden'); })); }
  var g = null, suppress = 0;
  document.addEventListener('pointerdown', function (e) {
    if (e.button > 0) return;
    var c = e.target.closest && e.target.closest(SEL);
    if (!c || e.target.closest('button, select, input, .swiper-pagination, cl-page-dots, cl-flickity-controls')) return;
    var k = kind(c), tr = track(c, k);
    g = { c: c, k: k, tr: tr, x: e.clientX, y: e.clientY, dx: 0, lock: 0, base: tr ? tx(tr) : 0, id: e.pointerId,
          w: (c.querySelector('.shg-swiper, .flickity-viewport') || c).clientWidth || c.clientWidth };
  }, true);
  document.addEventListener('pointermove', function (e) {
    if (!g || e.pointerId !== g.id) return;
    var dx = e.clientX - g.x, dy = e.clientY - g.y;
    if (!g.lock) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      g.lock = Math.abs(dx) > Math.abs(dy) ? 1 : -1;
      if (g.lock === 1 && g.tr) g.tr.style.transition = 'none';
      if (g.lock === 1) try { g.c.setPointerCapture(e.pointerId); } catch (er) {}
    }
    if (g.lock !== 1) return;
    g.dx = dx;
    if (g.tr) { g.tr.style.transitionDuration = '0ms'; g.tr.style.transform = g.k === 'sw' ? 'translate3d(' + (g.base + dx) + 'px,0,0)' : 'translateX(' + (g.base + dx) + 'px)'; }
  }, true);
  function end(e) {
    if (!g || (e && e.pointerId !== g.id)) return;
    var s = g; g = null;
    if (s.lock !== 1) return;
    if (s.tr) s.tr.style.transition = '';
    var dir = Math.abs(s.dx) > Math.min(60, s.w * 0.15) ? (s.dx < 0 ? 1 : -1) : 0;
    suppress = Date.now() + 400;
    if (s.k === 'sw') {
      var i = +(s.c.getAttribute('data-cl-i') || 0);
      var slides = s.tr ? [].slice.call(s.tr.children).filter(function (x) { return /swiper-slide/.test(x.className); }) : [];
      var vw = s.c.querySelector('.shg-swiper') || s.c;
      var per = slides.length ? Math.max(1, Math.round(vw.clientWidth / (slides[0].getBoundingClientRect().width || vw.clientWidth))) : 1;
      var max = Math.max(0, slides.length - per);
      var n = i + dir;
      if (max === 0) n = 0; else if (n > max || n < 0) n = Math.max(0, Math.min(max, n));  /* arraste nao da a volta */
      window.clSwGo ? window.clSwGo(s.c, n) : 0;
      if (max === 0 && s.tr) { s.tr.style.transitionDuration = '300ms'; s.tr.style.transform = 'translate3d(0,0,0)'; }
    } else if (s.k === 'flk') {
      window.clFlkGo && window.clFlkGo(s.c, +(s.c.getAttribute('data-cl-i') || 0) + dir);
    } else if (dir) {
      pressGo(s.c, pressIdx(s.c) + dir);
    }
  }
  document.addEventListener('pointerup', end, true);
  document.addEventListener('pointercancel', end, true);
  document.addEventListener('click', function (e) {
    if (Date.now() < suppress && e.target.closest && e.target.closest(SEL)) { e.preventDefault(); e.stopPropagation(); suppress = 0; }
  }, true);
})();
